import { render, staticRenderFns } from "./ProfileLocations.vue?vue&type=template&id=19e9808e&scoped=true&"
import script from "./ProfileLocations.vue?vue&type=script&lang=js&"
export * from "./ProfileLocations.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLocations.vue?vue&type=style&index=0&id=19e9808e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9808e",
  null
  
)

export default component.exports